import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DadosTesteVitalidadeService {
  imgPerguntas(): Observable<any> {
    return of([
      {
        //Você consegue levantar de uma cadeira sem usar as mãos?
        pergunta: 1,
        opcaoUm: [
          //Sim, com facilidade
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Levantando-se com confiança do sofá@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Senhora elegante levantando da poltrona@2x.png',
          },
        ],
        opcaoDois: [
          //Sim, mas com alguma dificuldade
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Esforço à Mesa na Cozinha@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher se levantando com dificuldade no quarto@2x.png',
          },
        ],
        opcaoTres: [
          // Preciso apoiar as mãos
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Fazendo Esforço para Levantar do Sofá@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher se levantando à mesa da cozinha@2x.png',
          },
        ],
      },
      {
        //Você consegue ficar em um pé só por alguns segundos?
        pergunta: 2,
        opcaoUm: [
          //Sim, tranquilamente
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Equilíbrio divertido na sala de estar-1@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher estilosa em sala aconchegante@2x.png',
          },
        ],
        opcaoDois: [
          //Com alguma dificuldade
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Equilíbrio divertido na sala de estar@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Idosa Equilibrando na Sala Aconchegante@2x.png',
          },
        ],
        opcaoTres: [
          //Não consigo
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem com dor no joelho na sala@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Conforto em Meio à Preocupação@2x.png',
          },
        ],
      },
      {
        //Você consegue agachar e levantar com segurança?
        pergunta: 3,
        opcaoUm: [
          //Sim, sem dificuldade
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem sorridente encontra uma moeda no passeio@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher elegante amarrando o tênis no passeio@2x.png',
          },
        ],
        opcaoDois: [
          //Tenho alguma dificuldade
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem com dor nas costas alcançando moeda@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Laço Difícil sob as Luzes da Cidade@2x.png',
          },
        ],
        opcaoTres: [
          //Tenho muita dificuldade
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem com dor tentando alcançar moeda@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Idosa em Dificuldade na Sala Aconchegante@2x.png',
          },
        ],
      },
      {
        //Você consegue alcançar os pés para colocar uma meia ou calçado?
        pergunta: 4,
        opcaoUm: [
          //Sim, facilmente
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Ajustando Meia no Quarto Aconchegante@2x.png',
          },

          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Vovó Calçando Sapatilhas de Oncinha@2x.png',
          },
        ],
        opcaoDois: [
          // Com alguma dificuldade
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Lutando com a Meia no Campo@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher Vestindo Meia na Sala Aconchegante@2x.png',
          },
        ],
        opcaoTres: [
          //Tenho muita dificuldade
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Lutando com a Meia no Carro (1)@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Preocupação ao Calçar a Meia@2x.png',
          },
        ],
      },
      {
        //Você consegue subir um lance de escadas sem precisar parar?
        pergunta: 5,
        opcaoUm: [
          //Sim
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Satisfeito Subindo no Shopping@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Subindo com Alegria em Casa@2x.png',
          },
        ],
        opcaoDois: [
          //Preciso diminuir o ritmo
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Cauteloso Subindo as Escadas@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Senhora Subindo Escadas com Dificuldade@2x.png',
          },
        ],
        opcaoTres: [
          //Preciso parar ou tenho muita dificuldade
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Subindo Escadas no Parque@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher Exausta na Escadaria@2x.png',
          },
        ],
      },
      {
        //Você sente dificuldade para realizar atividades simples do dia a dia?
        pergunta: 6,
        opcaoUm: [
          //Raramente
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Passeio Alegre com Cachorro na Cidade@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher alcançando livro na estante@2x.png',
          },
        ],
        opcaoDois: [
          //Às vezes
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem com Dor nas Costas ao Erguer Caixa@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Organizando o armário em casa@2x.png',
          },
        ],
        opcaoTres: [
          //Frequentemente
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem lutando para ler documentos@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Caminhada Cansativa com o Cachorro@2x.png',
          },
        ],
      },
      {
        //Você costuma dormir cerca de 7 a 9 horas por noite e acordar sentindo que descansou?
        pergunta: 7,
        opcaoUm: [
          //Sim, geralmente durmo bem e acordo descansado(a)
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Manhã feliz no quarto aconchegante@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Alongamento Alegre às 7 da Manhã@2x.png',
          },
        ],
        opcaoDois: [
          //Meu sono varia ou nem sempre acordo descansado(a)
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Despertar Preguiçoso no Quarto Gamer@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Manhã Sonolenta no Quarto Aconchegante@2x.png',
          },
        ],
        opcaoTres: [
          //Tenho dificuldade frequente para dormir ou acordo cansado(a)
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Manhã Sonolenta no Quarto da Cidade@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Manhã Sonolenta no Quarto Aconchegante-2@2x.png',
          },
        ],
      },
      {
        //Você pratica alguma atividade de lazer semanalmente?
        pergunta: 8,
        opcaoUm: [
          //Sim, toda semana
          {
            ordemPergunta: 1,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Treino de tríceps com disciplina@2x.png',
          },
          {
            ordemPergunta: 1,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Alongamento ensolarado na academia@2x.png',
          },
        ],
        opcaoDois: [
          //Às vezes
          {
            ordemPergunta: 2,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Pausa Exausta no Campo de Futebol@2x.png',
          },
          {
            ordemPergunta: 2,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Caminhada Dourada no Parque@2x.png',
          },
        ],
        opcaoTres: [
          //Raramente ou nunca
          {
            ordemPergunta: 3,
            sexo: 1,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/masculino/Homem Entediado no Sofá@2x.png',
          },
          {
            ordemPergunta: 3,
            sexo: 2,
            img: './../../../../../../assets/app-assets/images/quiz-teste-vitalidade/perguntas/feminino/Mulher Cansada ao Celular na Cozinha@2x.png',
          },
        ],
      },
    ]);
  }
}
